import { render, staticRenderFns } from "./ticket-select-ajax.vue?vue&type=template&id=a497b604&scoped=true&"
import script from "./ticket-select-ajax.vue?vue&type=script&lang=js&"
export * from "./ticket-select-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a497b604",
  null
  
)

export default component.exports